<div class="container d-flex justify-content-center align-items-center mt-7">
    <div class="text-center">
        <div class="mb-4">
            <!-- Cancel Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="red" class="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                <path d="M10.3 5.3a.5.5 0 0 1 0 .7L8.707 8l1.593 1.593a.5.5 0 0 1-.707.707L8 8.707l-1.593 1.593a.5.5 0 0 1-.707-.707L7.293 8 5.7 6.407a.5.5 0 1 1 .707-.707L8 7.293l1.593-1.593a.5.5 0 0 1 .707 0z" />
            </svg>
        </div>
        <h2 class="mb-4">Paiement annulé!</h2>
        <p class="mb-4">Votre paiement a été annulé. Si vous avez des questions, veuillez nous contacter.</p>
        <div>
            <a [href]="redirectToWebflow('/recherche-studios')" target="_parent" class="btn btn-outline-studiomap"><i class="ni ni-bullet-list-67 mr-2"></i>Nos studios</a>
        </div>
    </div>
</div>